import { type TFunction } from 'i18next';

import { StatusBadge } from '@/components/common';
import { parseWallClock } from '@/utils/wallClock';

import type { MatingRecord } from '../types';

const statusColors = {
  Active: { bg: 'bg-green-100', text: 'text-green-700' },
  Pending: { bg: 'bg-yellow-100', text: 'text-yellow-700' },
  'On-hold': { bg: 'bg-orange-100', text: 'text-orange-700' },
};

export const getLoadedSourceColumnDefs = (
  t: TFunction,
  { showShipment = false }: { showShipment?: boolean } = {},
) => [
  {
    field: 'checkbox',
    headerName: '',
    width: 10,
    checkboxSelection: true,
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    suppressMovable: true,
    lockPosition: true,
    filter: false,
  },
  {
    field: 'recordName',
    headerName: t('onFarmImplant.sourceCard.recordAccount'),
    flex: 2,
    minWidth: 160,
    filter: 'agTextColumnFilter',
    cellRenderer: (params: { data: MatingRecord }) => {
      if (!params.data) return null;
      return (
        <div>
          <div className="font-medium text-gray-900">
            {params.data.recordName ?? '\u2014'}
          </div>
          <div className="text-xs text-gray-500">
            {params.data.accountName ?? ''}
          </div>
        </div>
      );
    },
  },
  {
    field: 'status',
    headerName: t('onFarmImplant.sourceCard.status'),
    flex: 0.8,
    minWidth: 80,
    filter: 'agTextColumnFilter',
    cellRenderer: (params: { value: string }) => {
      if (!params.value) return null;
      return <StatusBadge label={params.value} colorMap={statusColors} />;
    },
  },
  {
    field: 'date',
    headerName: t('onFarmImplant.sourceCard.date'),
    flex: 1,
    minWidth: 100,
    filter: 'agDateColumnFilter',
    valueFormatter: (params: { value: string | null }) => {
      if (!params.value) return '';
      return (
        parseWallClock(params.value)?.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        }) ?? ''
      );
    },
  },
  ...(showShipment
    ? [
        {
          field: 'shipmentNumbers',
          headerName: t('onFarmImplant.sourceCard.shipment'),
          flex: 1,
          minWidth: 110,
          filter: false,
          sortable: false,
          valueFormatter: (params: { value: string | null | undefined }) =>
            params.value ?? '',
        },
      ]
    : []),
  {
    field: 'embryoCount',
    headerName: t('onFarmImplant.sourceCard.emb'),
    flex: 0.5,
    minWidth: 50,
    filter: 'agNumberColumnFilter',
    cellClass: 'font-semibold',
  },
];
